import type { ReactNode } from 'react';
import { FRAMEWORK_FIRMA_PIE, enlacesPie } from '../lib/framework';

/**
 * Pie compacto, igual al del sitio del framework: firma y aviso legal arriba, disclaimer debajo.
 * El Radar (otro producto, cualquier sector) pasa su propia firma y su texto.
 */
export function FooterFramework({ firma = FRAMEWORK_FIRMA_PIE, children }: { firma?: string; children?: ReactNode }) {
  return (
    <footer className="pie-framework">
      <div className="pie-framework__wrap">
        <div className="pie-framework__cab">
          <span className="pie-framework__firma">{firma}</span>
          <nav className="pie-framework__links" aria-label="Legal">
            {enlacesPie().map((e) => (
              <a key={e.id} href={e.href}>
                {e.etiqueta}
              </a>
            ))}
          </nav>
        </div>
        <div className="pie-framework__texto">
          {children !== undefined ? children : (
            <>
              <p>
                <strong>Bien común de la cámara.</strong> El framework no es certificación, ranking
                entre socias, consultoría encubierta ni estándar obligatorio. Para las organizaciones
                socias de CESSI: empresas de producto, software factories, servicios, PyMEs
                tecnológicas, consultoras y startups de la industria del software y los servicios
                informáticos. No evalúa a los clientes de las socias.
              </p>
              <p>
                Las referencias normativas (Ley 25.326, ISO/IEC 42001) orientan y no constituyen
                asesoramiento legal. Las referencias a la biblioteca de la Mesa son de contenido, no
                textuales. Los aportes de los conversatorios se citan sin identificar personas ni
                empresas.
              </p>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
